import React, { Component, createRef  } from 'react';
import { withRouter, setCookie, login_check, loginUrl, pocketUrl, isLogin, deleteCookie, addToSwordCookie, getCookieCross } from './include/Common';
import {Helmet} from 'react-helmet';

import $ from 'jquery';
import axios from "axios";
import { Navigate } from "react-router-dom";
import Footer from './Footer';

class TodaySearch extends Component {
  constructor(props) {
    super(props);

    this.click = { startPos: null, endPos: null }; // 1~100
    this.sX = 0; this.sY = 0; this.eX = 0; this.eY = 0;

    this.canvas = null;
    this.ctx = null;
    this.width = 0;
    this.height = 0;
    this.diff = 0;

    this.r = 14;
    this.n = Math.sqrt((this.r * this.r) / 2);
    this.strokeColor = "#f2a133";

    this.isMouseDown = false;
    this.mouseMoved = false;

    this.grid = 10;
    //this.cellSize = 48;
    this.center = this.cellSize / 2;

    this.canvasARef = React.createRef();
    this.canvasCRef = React.createRef();
    this.wrapRef = React.createRef();

    this.popupTimer = null;
    this.wrongTimer = null;
    this.lastValid = { endPos: null, dir: null, overlay: null };

    this.state = {
      loading: true,
      error: null,
      dateInfo: null,
      cells: [],
      keywords: [],

      popupShow: false,

      // ✅ label overlay span들
      dragOverlay: null,       // { left, top, width, height }
      correctOverlays: [],     // 누적: [{ left, top, width, height }]
      wrongOverlay: null,      // { left, top, width, height, diagonal }
      formDate: '',
      loginCheck:false,
      puzzleReady: false,
    };
  }

   componentDidMount() {
      const publicUrl = process.env.PUBLIC_URL;
      document.addEventListener("pointerup", this.documentPointerUp);
      window.addEventListener("resize", this.handleResize);
      this.fetchData(publicUrl + '/api/getSearchWord.php');
      this.bindPointerEvents();
      
   }

   componentWillUnmount() {
      document.removeEventListener("pointerup", this.documentPointerUp);
      window.removeEventListener("resize", this.handleResize);
      this.unbindPointerEvents();
      window.clearTimeout(this.popupTimer);
      window.clearTimeout(this.wrongTimer);
   }
   handleResize = () => {
      this.initCanvasSizes();
   };
  documentPointerUp = () => {
    if (!this.isMouseDown) return;
    this.isMouseDown = false;
    this.mouseMoved = false;

    this.setState({ dragOverlay: null });

    this.setCanvas("c");
    if (this.ctx) this.ctx.clearRect(0, 0, this.width, this.height);
  };

   getRotateByDir = (dir) => {
      if (dir === "SE" || dir === "NW") return "45deg";
      if (dir === "NE" || dir === "SW") return "-45deg";
      return null; // 가로/세로
   };   
  async fetchData(url) {
    try {
      this.setState({ loading: true, error: null });
      const res = await axios.get(url);
      this.applyApiData(res.data);
    } catch (e) {
      this.setState({ loading: false, error: e?.message || "데이터 로드 실패" });
    }
  }

  applyApiData = (data) => {
    const arrayStr = data.arrayJSON || data.t_array;
    const keywordStr = data.keywordJSON || data.t_keyword;

    let cells = [];
    let keywords = [];

    try { cells = typeof arrayStr === "string" ? JSON.parse(arrayStr) : (arrayStr || []); } catch { cells = []; }
    try { keywords = typeof keywordStr === "string" ? JSON.parse(keywordStr) : (keywordStr || []); } catch { keywords = []; }
   let qDate = data.dateInfo.split("-");
   let qDateTxt = qDate[0] + "년 " + Number(qDate[1]) + "월 " + Number(qDate[2]) + "일";
    this.setState(
      {
        loading: false,
        error: null,
        quizDate: data.dateInfo || null,
        cells,
        keywords,
        popupShow: false,

        dragOverlay: null,
        correctOverlays: [],
        wrongOverlay: null,
        formDate:qDateTxt,
        loginCheck:data.login,

      },
      () => {
         this.initCanvasSizes();
         this.applyRevealedFromApi();
         this.applyRevealedFromCookie();
         this.setState({ puzzleReady: true });
      }
    );
  };

   initCanvasSizes() {
      const cols = this.grid; // 10
      const MAX_SIZE = 480;   // PC 최대 퍼즐 크기
      const PADDING = 16 * 2; // 좌우 여백 고려

      const vw = window.innerWidth;
      const availableWidth = Math.min(vw - PADDING, MAX_SIZE);

      // 🔥 cellSize를 화면 기준으로 계산
      this.cellSize = Math.floor(availableWidth / cols);
      this.center = this.cellSize / 2;

      const size = this.cellSize * cols;

      const a = this.canvasARef.current;
      if (a) {
         a.width = size;
         a.height = size;
      }

      const c = this.canvasCRef.current;
      if (c) {
         c.width = size;
         c.height = size;
      }
      this.setState({ puzzleReady: true });
   }

  bindPointerEvents() {
    const cEl = this.canvasCRef.current;
    if (!cEl) return;

    cEl.addEventListener("pointerdown", this.pointerDownHandler, { passive: false });
    cEl.addEventListener("pointermove", this.pointerMoveHandler, { passive: false });
    cEl.addEventListener("pointerup", this.pointerUpHandler, { passive: false });
    cEl.addEventListener("pointercancel", this.pointerCancelHandler, { passive: false });
    cEl.addEventListener("pointerleave", this.pointerCancelHandler, { passive: false });
  }

  unbindPointerEvents() {
    const cEl = this.canvasCRef.current;
    if (!cEl) return;

    cEl.removeEventListener("pointerdown", this.pointerDownHandler);
    cEl.removeEventListener("pointermove", this.pointerMoveHandler);
    cEl.removeEventListener("pointerup", this.pointerUpHandler);
    cEl.removeEventListener("pointercancel", this.pointerCancelHandler);
    cEl.removeEventListener("pointerleave", this.pointerCancelHandler);
  }

  setCanvas = (which) => {
    const el = which === "a" ? this.canvasARef.current : this.canvasCRef.current;
    if (!el) return;
    this.canvas = el;
    this.ctx = el.getContext("2d");
    this.width = el.width;
    this.height = el.height;
  };

  getRelativePosPointer = (ev, el) => {
      const rect = el.getBoundingClientRect();
      const PAD = 0;

      let x = (ev.clientX - rect.left) * (el.width / rect.width) - PAD;
      let y = (ev.clientY - rect.top)  * (el.height / rect.height) - PAD;

      return { x, y };
  };

  snapToCellCenter = (rawX, rawY) => {
    const col = Math.max(0, Math.min(this.grid - 1, Math.floor(rawX / this.cellSize)));
    const row = Math.max(0, Math.min(this.grid - 1, Math.floor(rawY / this.cellSize)));
    return { x: col * this.cellSize + this.center, y: row * this.cellSize + this.center };
  };

  // ✅ 1~100
  setPos = (x, y, loc) => {
    const col = Math.max(0, Math.min(this.grid - 1, Math.floor(x / this.cellSize)));
    const row = Math.max(0, Math.min(this.grid - 1, Math.floor(y / this.cellSize)));
    const idx = row * this.grid + col + 1;
    if (loc === "start") this.click.startPos = idx;
    else this.click.endPos = idx;
  };

  // ====== ✅ overlay 계산 ======
  idxToRC = (idx1) => {
    const z = idx1 - 1; // 0-based
    return { r: Math.floor(z / this.grid), c: z % this.grid };
  };

  getDirectionFromStartEnd = (startIdx, endIdx) => {
    const A = this.idxToRC(startIdx);
    const B = this.idxToRC(endIdx);
    const dr = B.r - A.r;
    const dc = B.c - A.c;

    if (dr === 0 && dc > 0) return "E";
    if (dr === 0 && dc < 0) return "W";
    if (dc === 0 && dr > 0) return "S";
    if (dc === 0 && dr < 0) return "N";

    // 대각선(절대값 같아야 직선 대각선)
    if (Math.abs(dr) === Math.abs(dc) && dr !== 0) {
      if (dr > 0 && dc > 0) return "SE";
      if (dr > 0 && dc < 0) return "SW";
      if (dr < 0 && dc > 0) return "NE";
      if (dr < 0 && dc < 0) return "NW";
    }
    return null;
  };

   // start/end를 바탕으로 label span style(left/top/width/height %) 계산
   buildOverlayRectPercent = (startIdx, endIdx) => {
      const A = this.idxToRC(startIdx);
      const B = this.idxToRC(endIdx);

      const minR = Math.min(A.r, B.r);
      const maxR = Math.max(A.r, B.r);
      const minC = Math.min(A.c, B.c);
      const maxC = Math.max(A.c, B.c);

      const cellsW = (maxC - minC + 1);
      const cellsH = (maxR - minR + 1);

      const leftPx = minC * this.cellSize;
      const topPx = minR * this.cellSize;
      const widthPx = cellsW * this.cellSize;
      const heightPx = cellsH * this.cellSize;

      return {
         left: `${leftPx}px`,
         top: `${topPx}px`,
         width: `${widthPx}px`,
         height: `${heightPx}px`,
         wPx: widthPx,
         hPx: heightPx,
      };
   };
   getBarIStyle = (dir, overlay) => {
      // ✅ width 기준 thickness 결정
      const screenWidth = window.innerWidth || document.documentElement.clientWidth;
      const thickness = screenWidth <= 480 ? 28 : 36;
      const pad = 8;      // 끝 여유(조절)

      const base = {
         position: "absolute",
         left: "50%",
         top: "50%",
         transformOrigin: "50% 50%",
         display: "block",
         height: `${thickness}px`,
         borderRadius: "999px",
         transform: "translate(-50%, -50%)",
      };

      // overlay에 wPx/hPx가 없을 수도 있으니 방어
      const wPx = overlay?.wPx ?? this.cellSize;
      const hPx = overlay?.hPx ?? this.cellSize;

      // 가로/세로는 해당 축 길이로
      if (dir === "E" || dir === "W") {
         return { ...base, width: `${wPx + pad}px` };
      }
      if (dir === "N" || dir === "S") {
         return { ...base, width: `${hPx}px`, transform: "translate(-50%, -50%) rotate(90deg)" };
      }

      // ✅ 대각선은 대각선 실제 길이 = sqrt(w^2 + h^2)
      const diag = Math.sqrt(wPx * wPx + hPx * hPx) - 20;
      
      if (dir === "SE" || dir === "NW") {
         //              \
         return { ...base, width: `${diag}px`, transform: "translate(-50%, -50%) rotate(45deg)" };
      }
      if (dir === "NE" || dir === "SW") {
         //              /
         return { ...base, width: `${diag}px`, transform: "translate(-50%, -50%) rotate(-45deg)" };
      }

      return { ...base, width: `${diag}px` };
   };
   setDragOverlay = (startIdx, endIdx) => {
      const dir = this.getDirectionFromStartEnd(startIdx, endIdx);
      if (!dir) {
         // ✅ 유효하지 않으면 기존 마지막 유효 overlay 유지 (아무 것도 안 함)
         return;
      }

      const rect = this.buildOverlayRectPercent(startIdx, endIdx);

      // ✅ 마지막 유효값 업데이트
      this.lastValid = { endPos: endIdx, dir, overlay: rect };

      // ✅ 화면 갱신
      this.setState({ dragOverlay: { ...rect, dir } });
   };

   setWrongOverlay = (startIdx, endIdx) => {
      const dir = this.getDirectionFromStartEnd(startIdx, endIdx);
      if (!dir) return;

      const rect = this.buildOverlayRectPercent(startIdx, endIdx);

      this.setState({ wrongOverlay: { ...rect, dir } });

      window.clearTimeout(this.wrongTimer);
      this.wrongTimer = window.setTimeout(() => {
         this.setState({ wrongOverlay: null });
      }, 600);
   };

   addCorrectOverlay = (startIdx, endIdx) => {
      const dir = this.getDirectionFromStartEnd(startIdx, endIdx);
      if (!dir) return;

      const rect = this.buildOverlayRectPercent(startIdx, endIdx);
      this.setState(prev => ({
         correctOverlays: [...prev.correctOverlays, { ...rect, dir }]
      }));
      };
      getOverlayIStyle = (dir) => {
      const rotate = this.getRotateByDir(dir);
      return rotate
         ? { transform: `rotate(${rotate})`, transformOrigin: "40% 10%", height: "545%" }
         : undefined;
   };
  // ===== pointer handlers =====
  pointerDownHandler = (ev) => {
      if (this.state.loading) return;

      ev.preventDefault();
      this.setCanvas("c");
      this.isMouseDown = true;

      const rel = this.getRelativePosPointer(ev, ev.target);
      const snapped = this.snapToCellCenter(rel.x, rel.y);

      this.sX = snapped.x;
      this.sY = snapped.y;

      this.setPos(this.sX, this.sY, "start");
      this.click.endPos = this.click.startPos; // 초기 end도 start로
      this.lastValid = {
      endPos: this.click.startPos,
      dir: null,
      overlay: this.buildOverlayRectPercent(this.click.startPos, this.click.startPos)
      };

      // 시작 드래그 표시(한 칸짜리)
      this.setState({ wrongOverlay: null, dragOverlay: { ...this.lastValid.overlay, dir: null } });

    //this.draw("mousedown");
  };

  pointerMoveHandler = (ev) => {
      if (!this.isMouseDown) return;
      ev.preventDefault();
      this.mouseMoved = true;

      const rel = this.getRelativePosPointer(ev, ev.target);
      this.eX = rel.x;
      this.eY = rel.y;

      const snapped = this.snapToCellCenter(this.eX, this.eY);

      // 후보 endPos
      this.setPos(snapped.x, snapped.y, "end");
      const candidateEnd = this.click.endPos;

      // ✅ 유효 방향일 때만 overlay 갱신 (유효하지 않으면 마지막 상태 유지됨)
      this.setDragOverlay(this.click.startPos, candidateEnd);

      // ✅ 캔버스 테두리 없애기로 했으니 항상 지움
      this.setCanvas("c");
      if (this.ctx) this.ctx.clearRect(0, 0, this.width, this.height);
  };

  pointerUpHandler = (ev) => {
    if (!this.isMouseDown) return;
    ev.preventDefault();

    this.isMouseDown = false;

    // 임시 캔버스 정리
    this.setCanvas("c");
    this.ctx.clearRect(0, 0, this.width, this.height);

    if (!this.mouseMoved) {
      this.setState({ dragOverlay: null });
      return;
    }
    this.mouseMoved = false;

    // 마지막 스냅
    const rel = this.getRelativePosPointer(ev, ev.target);
    const snapped = this.snapToCellCenter(rel.x, rel.y);
    this.eX = snapped.x;
    this.eY = snapped.y;

    //this.draw("mouseup"); // setPos end
    if (this.lastValid?.endPos) this.click.endPos = this.lastValid.endPos;
    // drag overlay 제거(결과로 바뀜)
    this.setState({ dragOverlay: null });

    const isCorrect = this.checkWordForwardOnly();
    if (isCorrect) {
      //console.log('isCorrect');
      // ✅ correct overlay 누적 추가
      this.addCorrectOverlay(this.click.startPos, this.click.endPos);

      // 기존대로: 영구 캔버스에 남기고 싶으면 유지
      // this.setCanvas("a");
      // this.fillSelectionBand(this.ctx, this.sX, this.sY, this.eX, this.eY);
      // this.draw("mouseup");

      this.revealMatchedWordAndPaintCells();
      //this.showPopup();
    } else {
      // ✅ wrong overlay 표시
      //console.log('isWrong');
      this.setWrongOverlay(this.click.startPos, this.click.endPos);
    }
  };

  pointerCancelHandler = (ev) => {
    ev.preventDefault();
    this.isMouseDown = false;
    this.mouseMoved = false;

    this.setState({ dragOverlay: null });

    this.setCanvas("c");
    if (this.ctx) this.ctx.clearRect(0, 0, this.width, this.height);
  };

  // ====== 정답 판정: 정방향만 ======
  checkWordForwardOnly = () => {
    const { keywords } = this.state;
    const sp = this.click.startPos;
    const ep = this.click.endPos;
    if (sp == null || ep == null) return false;
    return keywords.some((k) => !k.isRevealed && k.start === sp && k.end === ep);
  };

  getStepByDirection = (dir) => {
    const N = this.grid;
    const map = { N: -N, NE: -(N - 1), E: 1, SE: N + 1, S: N, SW: N - 1, W: -1, NW: -(N + 1) };
    return map[dir] ?? null;
  };

  getPathByKeyword = (k) => {
    const step = this.getStepByDirection(k.direction);
    if (step == null) return [];
    const path = [];
    let cur = k.start;
    let guard = 0;
    while (guard < 300) {
      path.push(cur);
      if (cur === k.end) break;
      cur += step;
      guard++;
    }
    if (guard >= 300) return [];
    return path;
  };

  revealMatchedWordAndPaintCells = () => {
      const publicUrl = process.env.PUBLIC_URL;

      const sp = this.click.startPos;
      const ep = this.click.endPos;
      const { loginCheck } = this.state;
      const matched = this.state.keywords.find((k) => !k.isRevealed && k.start === sp && k.end === ep);
      if (!matched) return;
      //console.log("word:", matched.word, matched);
      addToSwordCookie(matched?.word);
      const searchWordUrl = publicUrl + '/api/setCrossAnswer.php?week=' + this.state.quizDate + '&word=' + encodeURIComponent(matched?.word) + '&mode=search';
      //console.log(searchWordUrl);
      axios.get(searchWordUrl)
      .then(response => {
         //console.log('response.data:', response.data); // "OK|1"
         let retCookie = response.data.split("|");
         //console.log(retCookie);
         if(loginCheck){
            this.showExpPopup(retCookie[2]); 
         }
      })
      .catch(error => {
         console.error(error);
      });   
      //const retData = response.data;      
      this.setState((prev) => {
         const keywords = prev.keywords.map((k) => {
            if (!k.isRevealed && k.start === sp && k.end === ep) return { ...k, isRevealed: true };
            return k;
         });
         return { keywords };
      });

      const path = this.getPathByKeyword(matched);
      path.forEach((idx1) => {
         const el = this.wrapRef.current?.querySelector(`.wordquiz__letters span[data-idx="${idx1}"]`);
         if (el) el.classList.add("correct");
      });
  };
   showExpPopup = (exp) => {
      //console.log('showexpPopup:'+exp);
      const el = this.popupEl;
      const txt = this.popupTextEl;
      if (!el || !txt) return;

      // 숫자 그대로 출력
      txt.innerText = `+5`;

      // 강제로 보이기
      el.style.display = "block";
      el.style.visibility = "visible";
      el.style.opacity = "1";

      clearTimeout(this.popupTimer);

      this.popupTimer = setTimeout(() => {
         el.style.opacity = "0";
         el.style.visibility = "hidden";
         el.style.display = "none";
         if(exp =="10"){
            $("#popup--quizFinish").show().css('display', 'flex');
         }         
      }, 1200);
   };
   showPopup = () => {
      const el = this.popupEl;
      if (!el) return;

      // 강제로 보이게
      el.style.display = "block";
      el.style.visibility = "visible";
      el.style.opacity = "1";

      clearTimeout(this.popupTimer);

      this.popupTimer = setTimeout(() => {
         // 강제로 숨김
         el.style.opacity = "0";
         el.style.visibility = "hidden";
         el.style.display = "none";
      }, 900);
   };

   applyRevealedFromApi = () => {
      const revealed = (this.state.keywords || []).filter(k => k.isRevealed);

      if (!revealed.length) return;

      // ✅ 1) correctOverlays 미리 채우기 (누적)
      const overlays = revealed
         .map(k => {
            const dir = this.getDirectionFromStartEnd(k.start, k.end) || k.direction; // 둘 중 하나 사용
            const rect = this.buildOverlayRectPercent(k.start, k.end); // 현재 px기반 함수면 그대로 사용
            return { ...rect, dir };
         });

      this.setState({ correctOverlays: overlays }, () => {
         // ✅ 2) 셀 글자에 correct 클래스 미리 적용 (기존 방식 유지)
         revealed.forEach(k => {
            const path = this.getPathByKeyword(k);
            path.forEach(idx1 => {
            const el = this.wrapRef.current?.querySelector(`.wordquiz__letters span[data-idx="${idx1}"]`);
            if (el) el.classList.add("correct");
            });
         });
      });
   };

   applyRevealedFromCookie = () => {
      const revealedWordsCookie = getCookieCross("swordList");
      if (!revealedWordsCookie) return;

      const revealedWords = revealedWordsCookie.split(",");

      const matchedKeywords = this.state.keywords.filter(k =>
         revealedWords.includes(k.word)
      );

      if (!matchedKeywords.length) return;

      // ① 키워드 revealed 처리
      this.setState(prev => {
         const keywords = prev.keywords.map(k =>
            revealedWords.includes(k.word)
            ? { ...k, isRevealed: true }
            : k
         );
         return { keywords };
      }, () => {
         // ② 글자 + overlay 자동 표시
         matchedKeywords.forEach(k => {
            const path = this.getPathByKeyword(k);

            path.forEach(idx => {
            const el = this.wrapRef.current?.querySelector(
               `.wordquiz__letters span[data-idx="${idx}"]`
            );
            if (el) el.classList.add("correct");
            });

            const rect = this.buildOverlayRectPercent(k.start, k.end);
            this.setState(prev => ({
            correctOverlays: [...prev.correctOverlays, { ...rect, dir: k.direction }]
            }));
         });
      });

      if (revealedWordsCookie != '') {
         const publicUrl = process.env.PUBLIC_URL;
         let cookieWords = revealedWordsCookie.replaceAll(",", "|");
         let quizWordUrl = publicUrl + '/api/setCrossAnswer.php?week=' + this.state.quizDate + '&word=' + encodeURIComponent(cookieWords) + '&mode=search';
         console.log('cookie async' + quizWordUrl);
         //console.log('cookieWords async' + cookieWords);
         axios.get(quizWordUrl).then(response => {
            let retCookie = response.data.split("|");
            if (retCookie[0] == 'OK' && revealedWordsCookie) {
               deleteCookie('swordList');
            }
         });
      }      
   }; 

   getLabelFontSize = () => {
      const screenWidth = window.innerWidth || document.documentElement.clientWidth;
      return screenWidth <= 480 ? '14px' : '16px'; // 원하는 값으로 조절
   };     
   handelLoginClick = () => {
      const refUrl = process.env.REACT_APP_USER_WWW + '/snslogin/PocketLogingDone.php?loc=MySearch';
      window.location.href = loginUrl + '?ref=' + encodeURIComponent(refUrl);
   }     
   render() {

      const { loginCheck, revealedCount, loading, error, cells, keywords, popupShow, dragOverlay, correctOverlays, wrongOverlay, formDate } = this.state;
      const PAD = 0;
      const rows = 10;
      const cols = 10;

      const currentUrl = window.location.href;
      const structureData = {
         "@context": "https://schema.org",
         "@type": "WebSite",
         "name": "미니게임 - 지식포켓",
         "url": currentUrl,
      }
      const allSolved =
         keywords.length > 0 &&
         keywords.every(k => k.isRevealed);

      return (
         <>
            <Helmet>

               <title>미니게임 - 지식포켓</title>
               <meta name="keywords" content="지식포켓, 뉴스 용어, 시사 용어, 오늘의 용어, 용어 검색, OX 퀴즈, 객관식 퀴즈, 십자말풀이, 시사 상식, 뉴스 해설, 용어 사전" />
               <meta name="description" content="경제·시사 키워드가 숨어 있는 10×10 단어찾기 게임! 눈으로 찾고 손으로 체크하며, 뉴스 속 개념을 자연스럽게 익혀보세요."/>

               <meta property="og:type" content="website" />
               <meta property="og:site_name" content="지식포켓" />
               <meta property="og:title" content="미니게임 - 지식포켓" />
               <meta property="og:description" content="경제·시사 키워드가 숨어 있는 10×10 단어찾기 게임! 눈으로 찾고 손으로 체크하며, 뉴스 속 개념을 자연스럽게 익혀보세요."/>
               <meta property="og:url" content={currentUrl} />
               <meta property="og:image" content="https://cwstatic.asiae.co.kr/pocket/og_img.png" /> 
               <meta property="og:image:width" content="1200" />
               <meta property="og:image:height" content="630" />
               <meta property="og:locale" content="ko_KR" />

               <link rel="canonical" href={currentUrl}/>
               <script type="application/ld+json">
               { JSON.stringify(structureData)}
               </script>               
               
            </Helmet>         
            <main id="contents" data-page="quiz" className="page--quiz no-search-btn">
               <section className="section">
                  <div className="title-bx">
                     <h1 className="tit">퀴즈 </h1>
                  </div>
                  <></>
                  <div className="tab">
                     <ul className="tab-list">
                        <li><a href="/Today" className="tab-link"> 용어 퀴즈 </a></li>
                        <li><a href="/TodayCross" className="tab-link"> 십자말풀이 </a></li>
                        <li><a href="" id="tab-3" onClick={(e) => e.preventDefault()} className="tab-link active"> 미니 게임 </a></li>                        
                     </ul>
                  </div>
                  <div class="quiz-week-state">
                     <div class="week-selector__text"> {formDate} </div>
                  </div>

                  <div className="wordquiz__wrap" ref={this.wrapRef}>
                     <div
                        className="dragPad"
                        style={{
                           position: "relative",
                           width: this.grid * this.cellSize,
                           aspectRatio: "1 / 1", // 🔥 핵심
                           margin: "0 auto"
                        }}
                        >
                        {!allSolved && (
                           <canvas ref={this.canvasCRef} id="c" style={{ border:"0", position: "absolute", inset: 0, zIndex: 10, touchAction: "none" }} />
                        )}
                        <div
                           className="wordquiz"
                              style={{
                                 position: "relative",
                                 width: this.grid * this.cellSize,
                                 aspectRatio: "1 / 1", // 🔥 핵심
                                 margin: "0 auto"               
                           }}
                        >
                           {/* ✅ 퍼블리싱 방식 label overlay */}
                           <div className="wordquiz__label" 
                              style={{ 
                                 position:"absolute",
                                 inset:0,
                                 zIndex:1,
                                 pointerEvents:"none",
                                 boxSizing:"border-box",
                              }}
                           >
                              {this.state.puzzleReady && (
                              <>     
                                 {correctOverlays.map((o, i) => (
                                    <span key={`c-${i}`} className="correct" style={{ position: "absolute", left: o.left, top: o.top, width: o.width, height: o.height, fontSize: this.getLabelFontSize() }}>
                                       <i style={this.getBarIStyle(o.dir, o)} />
                                    </span>
                                 ))}

                                 {dragOverlay ? (
                                    <span className="drag" style={{ position: "absolute", left: dragOverlay.left, top: dragOverlay.top, width: dragOverlay.width, height: dragOverlay.height, fontSize: this.getLabelFontSize() }}>
                                       <i style={this.getBarIStyle(dragOverlay.dir, dragOverlay)} />
                                    </span>
                                 ) : null}

                                 {wrongOverlay ? (
                                    <span className="wrong" style={{ position: "absolute", left: wrongOverlay.left, top: wrongOverlay.top, width: wrongOverlay.width, height: wrongOverlay.height, fontSize: this.getLabelFontSize() }}>
                                       <i style={this.getBarIStyle(wrongOverlay.dir, wrongOverlay)} />
                                    </span>
                                 ) : null}
                              </>
                              )}                                 
                           </div>

                           {/* 글자 그리드 (1~100 data-idx) */}
                           <div
                           className="wordquiz__letters"
                           style={{
                              position: "absolute",
                              inset: 0,
                              zIndex: 5,
                              display: "grid",
                              gap: 0, // ✅ 혹시 있으면 반드시 0
                              gridTemplateColumns: `repeat(${this.grid}, ${this.cellSize}px)`,
                              gridTemplateRows: `repeat(${this.grid}, ${this.cellSize}px)`,
                           }}
                           >
                           {cells.map((ch, i) => {
                              const idx = i + 1;
                              return (
                                 <span
                                 key={idx}
                                 data-idx={idx}
                                 className="cell"
                                 style={{
                                    boxSizing: "border-box",
                                    width: this.cellSize,
                                    height: this.cellSize,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    userSelect: "none",
                                    color: keywords.some(k => k.isRevealed && this.getPathByKeyword(k).includes(idx))
                                       ? "#fff"
                                       : '#111'                                 
                                 }}
                                 >
                                 {ch}
                                 </span>
                              );
                           })}
                           </div>

                           {/* (선택) 캔버스가 필요 없으면 지워도 됨 */}
                           <canvas ref={this.canvasARef} id="a" style={{ border:"0", position: "absolute", inset: 0, zIndex: 0, pointerEvents: "none" }} />
                           
                        </div>
                     </div>
                     <aside
                        ref={el => (this.popupEl = el)}
                        className="wordquiz__popup"
                        >
                        ✨ <span ref={el => (this.popupTextEl = el)}>+0</span> Exp
                     </aside>
                       
                  </div>

                  <div className="container">
                     <p className="wordquiz__notice">
                        💡 아래 단어를 위 퍼즐에서 찾아 <em>순서대로 드래그</em> 해보세요!
                     </p>

                     <div className="wordquiz__quest">
                        {keywords.map((k, idx) => (
                        <a
                           key={k.word + idx}
                           href={k.isRevealed ? `/View/${k.t_idx}` : undefined}
                           className={`quest ${k.isRevealed ? "active" : ""}`}
                           onClick={(e) => {
                              if (!k.isRevealed) {
                              e.preventDefault(); // ❗ 안 열릴 때만 막음
                              }
                           }}
                        >
                           {k.word}
                        </a>
                        ))}
                     </div>  
                  </div>  
                     {loginCheck == '1' ? (
                        <a href="/MySearch" className="quiz__result__txt" id="link_viewHistory" > 퀴즈 내역 보러 가기 👉 </a>
                     ) : (
                        <button className="quiz__result__txt" id="link_login" onClick={() => this.handelLoginClick()}> 로그인하고 퀴즈 내역 남기기 👉 </button>
                     )}

               </section>

            </main >
            <Footer />
            <aside class="popup" id="popup--quizFinish">
               <div class="popup__wrap">
                  <div class="popup__head">
                     <button type="button" class="popup__close"><span class="sr-only">닫기</span></button>
                  </div>
                  <i class="ico"> 🎉 </i>
                  <p class="tit">추가 10 Exp 획득!</p>
               </div>
            </aside>               
         </>
      );
   }
}

export default withRouter(TodaySearch);